export enum DraftStatus {
  All = 'All',
  Scheduled = 'Scheduled',
  Draft = 'Draft',
  Published = 'Published',
}
